import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// Single place that owns the Mapbox token + CSS import. Both map consumers
// (report/MapWidget.js and requests/pzValidationRequestModal.js) import the
// configured handle from here instead of reaching for window.mapboxgl.
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;

export default mapboxgl;
